import React from 'react';
import { useTheme } from '@emotion/react';
// Mui components
import { Box } from '@mui/material';

function HorizontalDivider({ color }) {

    const theme = useTheme();
    return (
        <Box sx={{ borderBottom: `2px solid ${color ?? theme.palette.backgroundSecondary.main}` }} />
    );
}

export default HorizontalDivider;